module.exports = __webpack_public_path__ + "img/brand_2.34044dfe.png";